app.factory('recipientgroupService', function($http) {
    return {
        list: function(page) {                          
            return $http.get('/receivergroup?page='+page);
        },
        show: function(id) {
            return $http.get('/receivergroup/'+id);
        },
        create: function(){
            return $http.get('/receivergroup/create');
        },
        store: function(data) {
            return $http.post('/receivergroup',data);
        },
        edit: function(id){
            return $http.get('/receivergroup/'+id+'/edit');
        },
        update: function(id,data){
            return $http.put('/receivergroup/'+id,data);
        },
        delete: function(id) {
            return $http.delete('/receivergroup/'+id);
        },
        filters: function() {
            return $http.get('/receivergroup/filters');
        },
        copy: function(params){            
            return $http.post('/receivergroup/copy',params);
        },
        activate: function(ids){
            return $http.post('/receivergroup/activate',ids);
        }        
    };
});